import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  password_email:string;
  forgotPass: FormGroup;
  tempPass: boolean = false;



  constructor() { }

  ngOnInit() {

    this.forgotPass = new FormGroup ({
     
      emailpass: new FormControl('',[Validators.required, 
        Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')])
      
     
  })
  }

}
